$(document).on "turbolinks:load", ->
  #uncheck checkbox
#  $("input[type='submit']").attr("disabled");
  $('#user-terms-check').prop('checked', false);

  $('input[name=\'user-terms-check\']').on('change keyup', ->
    if $('#user_first_name').val() != '' and $('#user_last_name').val() != '' and $('#user_email').val() != '' and $('#prevent-paste').val() != '' and $('#user_password').val() != '' and $('#user_password_confirmation').val() != '' and $('input[name=\'user-terms-check\']').is(':checked') == true
      $('input[name=\'#activate-admin-btn\']').removeAttr 'disabled'
    else
      $('input[name=\'#activate-admin-btn\']').attr 'disabled', 'disabled'
    return
  );

  $("#user_first_name, #user_last_name, #user_email, #prevent-paste, #user_password, #user_password_confirmation" ).on("change keyup paste", ->
    if $('#user_first_name').val() != '' and $('#user_last_name').val() != '' and $('#user_email').val() != '' and $('#prevent-paste').val() != '' and $('#user_password').val() != '' and $('#user_password_confirmation').val() != '' and $('input[name=\'user-terms-check\']').is(':checked') == true
      $('input[name=\'#activate-admin-btn\']').removeAttr 'disabled'
    else
      $('input[name=\'#activate-admin-btn\']').attr 'disabled', 'disabled'
    return
  );
#  $('input[name=\'category\']').on 'change', ->
#    if $('input[name=\'user-terms-check\']').is(':checked') == true
#      $('input[type=\'submit\']').removeAttr 'disabled'
#    return

#
#$("#user-terms-check").on("change", (e) ->
#  if $(this).is(":checked")
#    $("#activate-admin-btn").hide()
#    $("#activate-admin-btn").removeClass("disabled")
#  else
#    $("#activate-admin-btn").show()
#    $("#activate-admin-btn").addClass("disabled")
#)
#
#$('#user_user_agreement').change( ()
#  $('#activate-admin-btn').prop("disabled", !this.checked)
#).change()
